import findIndex from 'lodash.findindex';

const constrain = (weightings, percentageWeightings) => {
  let totalPercentage = Object.keys(percentageWeightings).reduce((a, b) => {
    return a + (percentageWeightings[b] || 0);
  }, 0);

  const totalNonpercentageWeighting = Object.keys(weightings).reduce((a, b) => {
    return a + (percentageWeightings[b] != null ? 0 : weightings[b]);
  }, 0);

  if (
    totalPercentage > 1 + 1e-6 ||
    (totalPercentage < 1 - 1e-6 && totalNonpercentageWeighting <= 0)
  ) {
    // Rescale percentageWeightings to 100%
    percentageWeightings = { ...percentageWeightings };
    Object.keys(percentageWeightings).forEach((key,_,a) => {
      percentageWeightings[key] = percentageWeightings[key] != null && !!totalPercentage
        ? percentageWeightings[key] / totalPercentage
        : 1 / a.length
    });
    totalPercentage = 1;
  }

  const totalPercentageWeighting = totalPercentage === 1
    ? Object.keys(weightings).reduce((a, b) => a + weightings[b], 0)
    : totalNonpercentageWeighting * (totalPercentage / (1 - totalPercentage));

  const constrained = { ...weightings };
  Object.keys(weightings).forEach(key => {
    if (percentageWeightings[key] != null) {
      constrained[key] = totalPercentage && totalPercentageWeighting
        ? totalPercentageWeighting * (percentageWeightings[key] / totalPercentage)
        : percentageWeightings[key]
    }
  });

  return constrained;
};

const graphic = (state, action) => {
  if (action.type === 'LOAD_PARAMS') {
    return { ...state, ...action.params.graphic };
  }
  if (action.type === 'SET_GRAPHIC_LAYOUT') {
    return { ...state, layout: action.layout };
  }
  if (action.type === 'SET_GRAPHIC_AGGREGATION') {
    return { ...state, aggregateBy: action.aggregateBy };
  }
  return state;
};

const main = (state, action) => {
  if (action.type === 'LOAD_PARAMS') {
    const newState = { 
      ...state,
      entry: {
        ...state.entry,
        original: {
          ...state.entry.original,
          entityCCY: state.wtRegionCCYOptions[state.wtRegion][0].value
        }
      }
    };
    if (action.params.split) {
      newState.performanceSplit = JSON.parse(action.params.split);
      newState.incomeSplit = JSON.parse(action.params.split);
      newState.compositionSplit = JSON.parse(action.params.split);
    }
    return newState;
  }

  if(action.type === 'SAVE_COMPLIANCE_TEXT'){
    const subtitlesLookup = {
      P: "performanceHelpLabel",
      I: "incomeHelpLabel",
      S: "riskAdjReturnsHelpLabel",
      R: "riskHelpLabel",
      F: "feesHelpLabel"
    }
    const footnotesLookup = {
      P: "riskDescLabel",
      I: "incomeDescLabel",
      S: "riskAdjReturnsDescLabel",
      R: "riskDescLabel",
      F: "feesDescLabel",
    }
    const titlesLookup = {
      P: "performanceLabel",
      I: "incomeLabel",
      S: "riskAdjReturnsLabel",
      R: "riskLabel",
      F: "feesLabel",
    }
    const labelsLookup = {
      'P': "maximizePerformanceLabel",
      'I': "maximizeIncomeLabel",
      'R': "minimizeRiskLabel",
      'S': "maximiseSharpeRatioLabel",
      'F': "reduceExpensesLabel",
    }
    const fdFieldLookup = {
      'fundPageURL': "websiteFundDetailsTableLabel",
      'morningstar': "filingsFundDetailsTableLabel",
      'inceptionDate': "inceptionDateFundDetailsTableLabel",
      'expenseRatioGross': "grossExpenseRatioFundDetailsTableLabel",
      'expenseRatio': "netExpenseRatioFundDetailsTableLabel",
      'sec30DayYieldSub': "subSEC30DayYieldFundDetailsTableLabel",
      'sec30DayYieldUnSub': "unsubSEC30DayYieldFundDetailsTableLabel",
      'expenseNote': "notesFundDetailsTableLabel",
    }
    const ptFieldLookup = {
      'inception': "sinceInceptionTableLabel",
      'commonPeriod': "commonPeriodPerformanceTableLabel",
      'mtd': "monthPerformanceTableLabel",
      'mos3': "monthPerformanceTableLabel",
      'yrs1': "yearPerformanceTableLabel",
      'yrs3': "yearPerformanceTableLabel",
      'yrs5': "yearPerformanceTableLabel",
      'yrs7': "yearPerformanceTableLabel",
      'yrs10': "yearPerformanceTableLabel",
    }
    const bestModelLookup = ["stayCloseToPortfolioLabel","bestWisdomTreeModelLabel"]
    const fffLookup = {
      'fff-beta': "betaFactorLoadingsLabel",
      'fff-size': "sizeFactorLoadingsLabel",
      'fff-value': "valueFactorLoadingsLabel",
      'fff-quality': "qualityFactorLoadingsLabel",
      'fff-investments': "investmentFactorLoadingsLabel"
    }
    const ccyLookup = {
      'USD': "usDollarLabel",
      'CAD': "canadianDollarLabel",
      'GBP': "gbpLabel",
      'EUR': "euroLabel",
    }
    return {
      ...state,
      complianceText: action.text,
      keyMetrics: state.keyMetrics.map(d => ({
        ...d,
        title: titlesLookup[d.key] ? action.text[titlesLookup[d.key]] : d.title,
        subtitle: action.text[subtitlesLookup[d.key]],
        footnote: action.text[footnotesLookup[d.key]],
      })),
      investmentGoalOptions: state.investmentGoalOptions.map(d => ({
        ...d,
        label: labelsLookup[d.value] ? action.text[labelsLookup[d.value]] : d.label
      })),
      fundDetailsFields: state.fundDetailsFields.map(d => ({
        ...d,
        name: fdFieldLookup[d.key] ? action.text[fdFieldLookup[d.key]] : d.name
      })),
      performanceTableFields: state.performanceTableFields.map(d => ({
        ...d,
        name: (d.prefix ? d.prefix : "") + (ptFieldLookup[d.key] ? action.text[ptFieldLookup[d.key]] : "")
      })),
      bestModelOptions: state.bestModelOptions.map(d => ({
        ...d,
        label: action.text[bestModelLookup[+d.value]]
      })),
      famaFrench5FactorFields: state.famaFrench5FactorFields.map(d => ({
        ...d,
        name: action.text[fffLookup[d.key]]
      })),
      wtRegionCCYOptions: {
        ...state.wtRegionCCYOptions,
        [state.wtRegion]: state.wtRegionCCYOptions[state.wtRegion].map(d => ({
          ...d,
          label: action.text[ccyLookup[d.value]]
        }))
      },
      customStressTestColumnLabelsLookup: {
        equity: "equityLabel",
        rates: "ratesLabel",
        other: "otherLabel",
      },
      customStressTestColumns: {
        equity: {
          "betaEquityUS": action.text.usEquityMarketLabel,
          "betaEquityEuroDev": action.text.europeanEquityMarketLabel,
          "betaEquityAsiaDev": action.text.japaneseEquityMarketLabel,
          "betaEquityChina": action.text.chineseEquityMarketLabel,
          "betaEquityEm": action.text.emergingMarketsEquityMarketLabel,
        },
        rates: {
          "betaRates3moUS": action.text.tBill90daysLabel,
          "betaRates1yrUS": action.text.year1Label,
          "betaRates5yrUS": action.text.year5Label,
          "betaRates10yrUS": action.text.year10Label,
          "betaRates30yrUS": action.text.year30Label,
          "betaCreditSpreadBBBUS": action.text.usCorpBondSpreadLabel,
        },
        other: {
          "betaSmb": action.text.sizeSMBLabel,
          "betaHml": action.text.valueHMLLabel,
          "betaUSDTradeweighted": action.text.usdindexLabel,
          "betaGold": action.text.goldPriceLabel,
          "betaOil": action.text.oilPriceLabel,
        }
      },
    }
  }

  if (action.type === 'ADD_FUNDS') {
    const weightings = { ...state.entry[action.side].weightings };
    const { lastRemovedWeighting } = state.entry[action.side];
    action.funds.forEach((f,i) => 
      (weightings[f.ticker] = (i === 0 && lastRemovedWeighting) ? lastRemovedWeighting : 1000000));

    // Set the name to null if a model is being used and will be reset
    let name = state.entry[action.side].modelProposalTicker !== null ? null : state.entry[action.side].name;
    
    return {
      ...state,
      entry: {
        ...state.entry,
        [action.side]: { 
          ...state.entry[action.side], 
          lastRemovedWeighting: null,
          portfolio: [...state.entry[action.side].portfolio, ...action.funds ],
          weightings: constrain(weightings, state.percentageWeightings),
          entityCCY: state.entry[action.side].entityCCY || state.wtRegionCCYOptions[state.wtRegion][0].value,
          modelProposalTicker: null,
          selectedModel: null,
          selectedModelFamily: 'null',
          name: name,
          usingModel: false,  
        },
              
      }
    };
  }

  if (action.type === 'REMOVE_FUND') {

    // Set the name to null if a model is being used and will be reset
    let name = state.entry[action.side].modelProposalTicker !== null ? null : state.entry[action.side].name;

    if(action.index === -1){
      return {
        ...state,
        entry: {
          ...state.entry,
          [action.side] : {
            ...state.entry[action.side],
            portfolio: [],
            weightings: {},
            modelProposalTicker: null,
            selectedModel: null,
            selectedModelFamily: 'null',
            name: name,
            usingModel: false,  
            selectedPersonalStrategy: 'null',
          },          
        },        
        percentageWeightings: {
          ...state.percentageWeightings,
          [action.side]: {}
        }
      }
    }

    const key = state.entry[action.side].portfolio[action.index].ticker;

    const weightings = { ...state.entry[action.side].weightings };
    const lastRemovedWeighting = weightings[key];
    delete weightings[key];

    const percentageWeightings = {
      ...state.percentageWeightings[action.side],
      [key]: null,
    };
    return {
      ...state,
      entry: {
        ...state.entry,
        [action.side]: {
          ...state.entry[action.side],
          lastRemovedWeighting,
          portfolio: [
            ...state.entry[action.side].portfolio.slice(0, action.index),
            ...state.entry[action.side].portfolio.slice(action.index + 1),
          ],
          weightings: constrain(weightings, percentageWeightings),
          modelProposalTicker: null,
          selectedModel: null,
          selectedModelFamily: 'null',          
          selectedPersonalStrategy: 'null',
          name: name,
          usingModel: false,  
        },        
      },
      
      percentageWeightings: {
        ...state.percentageWeightings,
        [action.side]: percentageWeightings,
      },
    };
  }

  if (action.type === 'SET_WEIGHTING') {

    // Set the name to null if a model is being used and will be reset
    let name = state.entry[action.side].modelProposalTicker !== null ? null : state.entry[action.side].name;

    return {
      ...state,
      entry: {
        ...state.entry,
        [action.side]: {
          ...state.entry[action.side],        
          weightings: constrain(
            {
              ...(state.preexistingWeightings[action.side] || state.entry[action.side].weightings),
              [action.key]: action.weighting,
            },
            state.percentageWeightings[action.side]
          ),
          modelProposalTicker: null,
          selectedModel: null,
          selectedModelFamily: 'null',
          name: name,
          usingModel: false, 
        },         
      },      
      preexistingWeightings: {
        ...state.preexistingWeightings,
        [action.side]: action.tentative
          ? state.preexistingWeightings[action.side] || state.entry[action.side].weightings
          : null
      }
    };
  }

  if (action.type === 'SET_PERCENTAGE_WEIGHTING') {

    // Set the name to null if a model is being used and will be reset
    let name = state.entry[action.side].modelProposalTicker !== null ? null : state.entry[action.side].name;

    const percentageWeightings = {
      ...state.percentageWeightings[action.side],
      [action.key]: action.weighting,
    };
    return {
      ...state,
      entry: {
        ...state.entry,
        [action.side]: {
          ...state.entry[action.side],
          weightings: constrain(state.entry[action.side].weightings, percentageWeightings),
          modelProposalTicker: null,
          selectedModel: null,
          selectedModelFamily: 'null',
          name: name,
        }
      },
      percentageWeightings: {
        ...state.percentageWeightings,
        [action.side]: percentageWeightings,
      },
    };
  }

  if (action.type === 'LOADING') {
    return { ...state, loading: true };
  }

  if (action.type === 'LOADING_COMPLETE') {
    return { ...state, loading: false };
  }

  if (action.type === 'SET_ANALYSIS') {
    return { 
      ...state, 
      analysis: action.analysis, 
      loading: false,
      monteCarlos: [
       {
          name: "Default scenario",
          id: null,
          permanent: false,
          needsSaving: false,
          expectedReturnAssumptions: action.analysis[0].monteCarlos[0].expectedReturnAssumptions,
          expectedVolatilityAssumptions: action.analysis[0].monteCarlos[0].expectedVolatilityAssumptions,
        },
        ...state.monteCarlos
      ]
    };
  }

  if (action.type === 'UPDATE_ANALYSIS_MONTE_CARLO'){
    return {
      ...state,
      analysis: state.analysis.map((a,i) => ({
        ...a,
        monteCarlos: action.data[i].monteCarlos,
      })),
      loading: false
    }
  }

  if (action.type === 'WT_DIALOG'){
    return {
      ...state,
      wtDialog: action.url
    }
  }
  if (action.type === 'CLOSE_WT_DIALOG'){
    return {
      ...state,
      wtDialog: null
    }
  }

  if (action.type === 'DIALOG') {
    return {
      ...state,
      dialog: {
        message: action.message,
        buttons: action.buttons || [{ label: 'OK' }],
        prompt: action.prompt,
        wide: action.wide || false,
      },
      loading: false,
    };
  }
  if (action.type === 'CLOSE_DIALOG') {
    return {
      ...state,
      dialog: null,
    };
  }

  if (action.type === 'CLEAR_ANALYSIS') {
    let proposed = { ...state.entry.proposed }
    if(Object.keys(proposed).length === 0){
      const proposedHoldings = state.analysis[1].holdings[0];
      proposed = {
        id: state.analysis[1].id,
        name: (state.analysis[1].name || "Unnamed portfolio")+" (Proposed)",
        portfolio: proposedHoldings.tickers
          .map((t,i) => ({ ticker: t, name: proposedHoldings.names[i] }) )
          .filter((t,i) => proposedHoldings.tickerWeights[i] > 0),
        weightings: proposedHoldings.tickers
          .reduce((t,v,i) => ({ ...t, [v]: proposedHoldings.tickerWeights[i] }), {}),
        entityCCY: state.analysis[1].entityCCY
      }
    }
    return { 
      ...state,
      analysis: null,
      performanceSplit: false,
      incomeSplit: false,
      compositionSplit: false,
      pdfStatus: 'unsent',
      ticketStatus: 'unsent',
      awaitingNewData: true,
      salesforceComplete: false,
      reportName: null,

      entry: {
        ...state.entry,
        compareMode: true,
        inFocus: "proposed",
        original: {
          ...state.entry.original,
          filterFundYears: false,
          filterFundSize: false,
        },
        proposed,
      },

      clientPdf: {
        ...state.clientPdf,
        status: "unsent",
        clientName: null,
        clientLogo: null,
        description: null,
        addlFees: 0,
        sections: [],
        stressTests: [],
      },

      pendingSaveToMyPortfolios: {   
        original: {
          portfolioId: null,
          complete: null,
          personalStrategyId: null,
        },
        proposed: {
          portfolioId: null,
          complete: null,
          personalStrategyId: null,
        }
      },

      customStressTests: state.customStressTests.filter(t => t.permanent)

    };
  }

  if (action.type === 'CLEAR_AND_LOAD_PORTFOLIO') {

    const holdings = action.portfolio.holdings[0];
    const totalValue = action.portfolio.totalValue || 1;

    const portfolio = holdings.tickers.map((ticker, i) => ({
      ticker,
      type: holdings.types[i],
      name: holdings.names[i],
    }));
    const weightings = {};
    holdings.tickers.forEach((ticker, i) => {
      weightings[ticker] = Math.round(100 * holdings.weights[i] * totalValue)/100;
    });

    // If the Personal Strategy has a benchmark then find it in list of benchmarks
    const selectedBenchmark = state.entry.benchmarks && action.portfolio.benchmarks? 
      state.entry.benchmarks.filter( benchmark => benchmark.externalID === action.portfolio.benchmarks[0].externalID)
      : null;

    const { inFocus } = state.entry;

    const entry = {
      ...state.entry,
      selectedBenchmark: selectedBenchmark && selectedBenchmark.length === 1 ? 
        selectedBenchmark[0].externalID : 'null',
      'original': {
        ...state.entry[inFocus],
        id: action.portfolio.id,
        portfolio,
        weightings,
        name: action.portfolio.name,
        investmentGoal: 'P',
        bestModel: false,
        entityCCY: action.portfolio.entityCCY || state.wtRegionCCYOptions[state.wtRegion][0].value,
        modelProposalTicker: null,
        usingModel: false,
      },
      'proposed': {},      
    };

    return { 
      ...state,
      analysis: null,
      performanceSplit: false,
      incomeSplit: false,
      compositionSplit: false,
      pdfStatus: 'unsent',
      ticketStatus: 'unsent',
      awaitingNewData: true,
      salesforceComplete: false,
      reportName: null,

      entry: entry,

      clientPdf: {
        ...state.clientPdf,
        status: "unsent",
        clientName: null,
        clientLogo: null,
        description: null,
        addlFees: 0,
        sections: [],
        stressTests: [],
      },

      pendingSaveToMyPortfolios: {   
        original: {
          portfolioId: null,
          complete: null,
          personalStrategyId: null,
        },
        proposed: {
          portfolioId: null,
          complete: null,
          personalStrategyId: null,
        }
      },

      customStressTests: state.customStressTests.filter(t => t.permanent)

    };
  }

  if (action.type === 'LOAD_FEATURES') {

    // Set up the exposures based on features
    var exposureOptions = [];

    if (action.features.exposuresGeography){
      exposureOptions.push({ value: 'country', label: 'Geography'})
    }
    if (action.features.exposuresMarketCap){
      exposureOptions.push({ value: 'marketCap', label: 'Market Cap' })
    }
    if (action.features.exposuresAssetClass){
      exposureOptions.push({ value: 'assetClass', label: 'Asset Class' })
    }
    if (action.features.exposuresSector){
      exposureOptions.push({ value: 'sector', label: 'Sector' })
    }
    if (action.features.exposuresBondCreditQuality){
      exposureOptions.push({ value: 'creditQuality', label: 'Credit Quality' })
    }
    if (action.features.exposuresBondMaturity){
      exposureOptions.push({ value: 'maturity', label: 'Bond Maturity' })
    }

    return { 
      ...state, 
      features: { 
        ...state.features,
        ...action.features,
      },
      exposureOptions: exposureOptions,
    }
  }

  if (action.type === 'SET_DATA') {
    return { ...state, data: action.data };
  }

  if (action.type === 'SET_PDF_STATUS') {
    return { ...state, pdfStatus: action.status };
  }

  if (action.type === 'SET_AWAIT_STATUS') {
    return { ...state, awaitingNewData: action.status };
  }

  if (action.type === 'SET_TICKET_STATUS') {
    return { ...state, ticketStatus: action.status };
  }

  if (action.type === 'SET_SALESFORCE_COMPLETE') {
    return { ...state, salesforceComplete: action.status };
  }

  if (action.type === 'SET_PERFORMANCE_SPLIT') {
    return { ...state, performanceSplit: action.split };
  }

  if (action.type === 'SET_INCOME_SPLIT') {
    return { ...state, incomeSplit: action.split };
  }

  if (action.type === 'SET_COMPOSITION_SPLIT') {
    return { ...state, compositionSplit: action.split };
  }

  if (action.type === 'SET_MONTE_CARLO_SPLIT') {
    return { ...state, monteCarloSplit: action.split };
  }

  if (action.type === 'LOAD_HISTORY') {
    return { ...state, history: action.data };
  }

  if (action.type === 'SET_DEFAULT_PORTFOLIO'){
    return { ...state, defaultPortfolio: action.portfolio }
  }

  if (action.type === 'SET_REPORT_NAME'){
    return { ...state, reportName: action.name.toUpperCase() }
  }
  

  if (action.type === 'SET_CLIENT_PDF') {
    return {
      ...state,
      clientPdf: {
        ...state.clientPdf,
        [action.key]: (action.key === 'stressTests' || action.key === 'sections')
          ? { 
              ...state.clientPdf[action.key], 
              [action.value]: action.bool
            }
          : action.value
      }
    }
  }

  if (action.type === 'LOAD_PORTFOLIO') {
    const holdings = action.portfolio.holdings[0];
    const totalValue = action.portfolio.totalValue || 1;

    const portfolio = holdings.tickers.map((ticker, i) => ({
      ticker,
      type: holdings.types[i],
      name: holdings.names[i],
    }));
    const weightings = {};
    holdings.tickers.forEach((ticker, i) => {
      weightings[ticker] = Math.round(100 * holdings.weights[i] * totalValue)/100;
    });

    // If the Personal Strategy has a benchmark then find it in list of benchmarks
    const selectedBenchmark = state.entry.benchmarks && action.portfolio.benchmarks? 
      state.entry.benchmarks.filter( benchmark => benchmark.externalID === action.portfolio.benchmarks[0].externalID)
      : null;

    const { inFocus } = state.entry;

    const entry = {
      ...state.entry,
      selectedBenchmark: selectedBenchmark && selectedBenchmark.length === 1 ? 
        selectedBenchmark[0].externalID : 'null',
      [inFocus]: {
        ...state.entry[inFocus],
        id: action.portfolio.id,
        portfolio,
        weightings,
        name: action.portfolio.name,
        investmentGoal: action.portfolio.investmentGoal === "C" || !action.portfolio.investmentGoal
          ? state.entry[inFocus].investmentGoal
          : action.portfolio.investmentGoal,
        bestModel: action.portfolio.bestModel || state.entry[inFocus].bestModel,
        entityCCY: action.portfolio.entityCCY || state.wtRegionCCYOptions[state.wtRegion][0].value,
        // Store the model portfolio ticker. This will be in the ticker field for True ModelPortfolios and in the 
        // modelProposalTicker field for user generated portfolios
        modelProposalTicker: action.portfolio.ticker ? action.portfolio.ticker : 
          (action.portfolio.modelProposalTicker ? action.portfolio.modelProposalTicker : null),
        usingModel: action.portfolio.ticker || action.portfolio.modelProposalTicker ? true : false
      },      
    };
    return {
      ...state,
      entry,
      // loadedEntry: entry,
      percentageWeightings: {
        ...state.percentageWeightings,
        [action.side]: {}
      },      
    };
  }

  if (action.type === 'DELETE_PORTFOLIO') {
    if (action.pending != null) {
      return {
        ...state,
        pendingDeletePortfolio: {
          ...state.pendingDeletePortfolio,
          [action.id]: action.pending,
        },
      };
    } else {
      const pendingDeletePortfolio = { ...state.pendingDeletePortfolio };
      delete pendingDeletePortfolio[action.id];

      return {
        ...state,
        history: state.history.filter(d => d.id !== action.id),
        pendingDeletePortfolio,
      };
    }
  }

  if (action.type === 'FAVORITE_PORTFOLIO') {
    if (action.pending != null) {
      return {
        ...state,
        pendingFavoritePortfolio: {
          ...state.pendingFavoritePortfolio,
          [action.id]: action.pending,
        },
      };
    } else {
      const pendingFavoritePortfolio = { ...state.pendingFavoritePortfolio };
      delete pendingFavoritePortfolio[action.id];

      const index = findIndex(state.history, d => d.id === action.id);
      return {
        ...state,
        history: [
          ...state.history.slice(0, index),
          { ...state.history[index], favorite: action.value },
          ...state.history.slice(index + 1),
        ],
        pendingFavoritePortfolio,
      };
    }
  }

  if (action.type === 'LOADING_TYPEAHEAD') {
    return { ...state, loadingFundSuggestions: { ...state.loadingFundSuggestions, [state.entry.inFocus]: true } };
  }

  if (action.type === 'LOADED_TYPEAHEAD') {
    return { ...state, loadingFundSuggestions: { ...state.loadingFundSuggestions, [state.entry.inFocus]: false } }; 
  }

  if (action.type === 'LOAD_TYPEAHEAD') {
    // Reject suggestions that aren't relevant by checking requestIndex, which would indicate
    // whether a more recent set of suggestions was already loaded
    if (action.requestIndex < state.latestFundSuggestionsRequestIndex) {
      // console.log('reject', action.query, 'keep', state.latestFundSuggestionsQuery) // DEBUG
      return state
    }

    return {
      ...state,
      fundSuggestions: action.data,
      loadingFundSuggestions: {
        ...state.loadingFundSuggestions,
        [state.entry.inFocus]: false,
      },
      latestFundSuggestionsQuery: action.query,// currently stored only for debugging
      latestFundSuggestionsRequestIndex: action.requestIndex,
    };
  }

  if (action.type === 'SET_FOCUS_PORTFOLIO') {
    return {
      ...state,
      entry: {
        ...state.entry,
        inFocus: action.portfolio,
      }
    }
  }

  if (action.type === 'SET_COMPARE_MODE') {
    return { 
      ...state, 
      entry: { 
        ...state.entry,
        inFocus: action.mode ? "proposed" : "original",
        compareMode: action.mode,
        proposed: action.mode ? { ...state.entry.original } : {},
      } 
    };
  }

  if (action.type === 'SET_COMPARE_MODE_ORIGINAL') {
    return { 
      ...state, 
      entry: { 
        ...state.entry,
        inFocus: "original",
        compareMode: true,
        proposed: { ...state.entry.original },
      } 
    };
  }

  if (action.type === 'SET_COMPARE_MODE_MODELS') {
    let oppositeSide = action.side === "original" ? "proposed" : "original";

    // If already in CompareMode then just highlight the other side
    if (action.currentMode){
      return {
        ...state,
        entry: {
          ...state.entry,
          inFocus: oppositeSide,
        },
      };
    } else {
      return {
        ...state,
        entry: {
          ...state.entry,
          compareMode: !action.currentMode,
          inFocus: oppositeSide,
          [oppositeSide]: {
            ...state.entry[action.side],
            name: null,
            portfolio: [],
            weightings: {},
            selectedModel: null,
            selectedModelFamily: 'null',
            showModelInput: false,
            usingModel: false,
          }
        },
        percentageWeightings: {
          ...state.percentageWeightings,
          [action.side === "original" ? "proposed" : "original"]: {}
        }
      };
    }
  }

  if (action.type === 'SET_COMPARE_MODE_SAVED_MODEL_PORTFOLIO') {
    
    let oppositeSide = action.side === "original" ? "proposed" : "original";

    // If not already in Compare model then switch to compare and create a blank
    // portfolio but don't switch sides
    if (!state.entry.compareMode){
      return {
        ...state,
        entry: {
          ...state.entry,
          compareMode: true,
          [oppositeSide]: {
            ...state.entry[action.side],
            name: null,
            portfolio: [],
            weightings: {},
            selectedModel: null,
            selectedModelFamily: 'null',
            showModelInput: false,
            usingModel: false,
          }
        },
        percentageWeightings: {
          ...state.percentageWeightings,
          [action.side === "original" ? "proposed" : "original"]: {}
        }
      };
    }
  }

  if (action.type === 'SET_PORTFOLIO_NAME') {
    return { 
      ...state, 
      entry: { 
        ...state.entry,
        [action.side]: {
          ...state.entry[action.side],
          name: action.name 
        }
      } 
    };
  }

  if (action.type === 'SET_PORTFOLIO_EMAIL') {
    return {
      ...state,
      entry: {
        ...state.entry,
        original: {
          ...state.entry.original,
          preparedForEmail: action.email
        }
      }
    }
  }

  if (action.type === 'SET_FIXED_WEIGHTING') {
    return { ...state, fixedWeighting: { ...state.fixedWeighting, [action.side]: action.value } };
  }

  if (action.type === 'LOAD_BENCHMARKS'){
    return {
      ...state,
      entry: {
        ...state.entry,
        benchmarks: action.benchmarks.map(d => ({ ...d, check: false })),
        selectedBenchmark: 'null',
      }
    }
  }

  if (action.type === 'LOAD_MODEL_PORTFOLIOS'){

    // Sort by model family and then model risk tolerance
    action.modelPortfolios.sort((a, b) => (a.modelFamilyRank > b.modelFamilyRank ||
      (a.modelFamilyRank === b.modelFamilyRank && a.modelRiskToleranceRank > b.modelRiskToleranceRank)) ? 1 : -1);

    // Get out the model families (now ordered)  
    let modelFamilies = action.modelPortfolios.map(function (model) {
      return model.modelFamily
    })

    // Slim down the list to unique families and store for later
    let uniqueModelFamilies = modelFamilies.filter(function (value, index, self) {
      return self.indexOf(value) === index;
    });

    return {
      ...state,
      entry: {
        ...state.entry,
        modelPortfolios: action.modelPortfolios.map(d => ({ ...d, check: false })),
        uniqueModelFamilies: uniqueModelFamilies,
      }
    }
  }

  if (action.type === 'LOAD_PERSONAL_STRATEGIES'){

    return {
      ...state,
      entry: {
        ...state.entry,
        personalStrategies: action.personalStrategies,
      }
    }
  }

  if (action.type === 'SET_SELECTED_PERSONAL_STRATEGY'){

    return {
      ...state,
      entry: {
        ...state.entry,
        [action.side]: {
          ...state.entry[action.side],
          selectedPersonalStrategy: action.personalStrategyId
        }
      }
    }
  }
  
  if (action.type === 'SET_SELECTED_MODEL'){

    return {
      ...state,
      entry: {
        ...state.entry,
        [action.side]: {
          ...state.entry[action.side],
          selectedModel: action.model
        }
      }
    }
  }

  if (action.type === 'SET_SELECTED_MODEL_FAMILY'){

    return {
      ...state,
      entry: {
        ...state.entry,
        [action.side]: {
          ...state.entry[action.side],
          selectedModelFamily: action.modelFamily
        }
      }
    }
  }

  if (action.type === 'SET_SHOW_MODEL_INPUT'){

    return {
      ...state,
      entry: {
        ...state.entry,
        [action.side]: {
          ...state.entry[action.side],
          showModelInput: action.show
        }
      }
    }
  }

  if (action.type === 'SET_BENCHMARK'){
    return {
      ...state,
      entry: {
        ...state.entry,
        selectedBenchmark: action.benchmark
      }
    }
  }
  if (action.type === 'SET_INVESTMENT_GOAL') {
    return { ...state, entry: { ...state.entry, original: { ...state.entry.original, investmentGoal: action.value} } };
  }
  if (action.type === 'SET_BEST_MODEL') {
    return { ...state, entry: { ...state.entry, original: { ...state.entry.original, bestModel: action.value } } };
  }
  if (action.type === 'SET_CURRENCY') {
    return { ...state, entry: { ...state.entry, original: { ...state.entry.original, entityCCY: action.value } } };
  }
  if (action.type === 'SET_FILTER_FUND_YEARS') {
    return { ...state, entry: { ...state.entry, original: { ...state.entry.original, filterFundYears: action.value } } };
  }
  if (action.type === 'SET_FILTER_FUND_SIZE') {
    return { ...state, entry: { ...state.entry, original: { ...state.entry.original, filterFundSize: action.value } } };
  }

  if (action.type === 'SAVING_TO_MY_PORTFOLIOS'){

    return {
      ...state,
      pendingSaveToMyPortfolios: {
        ...state.pendingSaveToMyPortfolios,
        [action.side]:  {
          portfolioId: action.portfolioId,
          complete: false,
          personalStrategyId: null,
        }
      }
    }
  }

  if (action.type === 'COMPLETED_SAVING_TO_MY_PORTFOLIOS'){

    // Figure out which side has been saved
    const side = state.pendingSaveToMyPortfolios.original.portfolioId === action.portfolioId ? 'original' : 'proposed';
    return {
      ...state,
      pendingSaveToMyPortfolios: {
        ...state.pendingSaveToMyPortfolios,
        [side]: {
          portfolioId: action.portfolioId,
          complete: true,
          personalStrategyId: action.personalStrategyId,
        }
      }
    }
  }

  if (action.type === 'RECORD_PARAMS') {
    const { examplePortfolio } = action.params
    let windowDefaultPortfolio = []
    if (examplePortfolio) {
      examplePortfolio.tickers.forEach((ticker, i) => {
        windowDefaultPortfolio.push({
          "Tickers": ticker,
          "Weights (% or $)": examplePortfolio.weights[i]
        })
      })
      windowDefaultPortfolio.columns = ["Tickers", "Weights (% or $)"]
    }

    return {
      ...state,
      ...(({ clientEmail, token, dataCallback, version, wtRegion, isoCode, loadExamplePortfolio, examplePortfolioName }) => 
        ({ 
          clientEmail, token, dataCallback, loadExamplePortfolio, examplePortfolioName, 
          windowDefaultPortfolio,
          version: version || state.version, 
          wtRegion: wtRegion || state.wtRegion,
          isoCode: isoCode
            ? isoCode.length === 2 && wtRegion
              ? `${isoCode}-${wtRegion}`
              : isoCode
            : state.isoCode,
        }))(action.params),
    };
  }

  if (action.type === 'LOAD_RISK_FREE_RATES'){
    return {
      ...state,
      riskFreeRates: action.rates
    }
  }

  if (action.type === 'LOAD_SAVED_STRESS_TESTS'){
    action.tests.forEach(e => {
      delete e._cls;
    })
    return {
      ...state,
      customStressTests: [
        ...(action.tests.length 
          ? action.tests.map(t => ({ ...t, needsSaving: false }) )
          : [{ 
              ...state.customStressTests[0],
              name: "Unnamed new scenario",
              id: null,
              permanent: false,
              needsSaving: true,
            }]),
        ...state.customStressTests.filter(t => t.id || t.permanent),
      ]
    }
  }

  if (action.type === 'LOAD_PERMANENT_STRESS_TESTS'){
    const stressTestKeys = Object.keys(state.stressTestKeys)
    action.tests.forEach(e => {
      delete e._cls;
    })
    return {
      ...state,
      stressTestKeys: {
        ...state.stressTestKeys,
        ...action.tests.filter(t => ~stressTestKeys.indexOf(t.name))
          .reduce((t, { name, title, description }) => ({
            ...t,
            [name]: { title, description }
          }), {})
      },
      customStressTests: [
        ...state.customStressTests,
        ...action.tests
          .filter(({ family }) => family === "hypothetical")
          .map(t => ({ ...t, permanent: true, name: t.title }))
      ],
      basicCustomStressTests: [
        ...state.basicCustomStressTests,
        ...action.tests.filter(({ family }) => family === "basic")
      ],
    }
  }

  if (action.type === 'SET_STRESS_TEST_SAVED'){
    if(action.saveAll){
      return {
        ...state,
        customStressTests: [
          ...state.customStressTests.filter(o => !o.permanent).map(d => ({ ...d, needsSaving: false })),
          ...state.customStressTests.filter(o => o.permanent)
        ]
      }
    } else {
      let index = state.customStressTests.map(d => d.id).indexOf(action.id) || state.selectedCustomStressTest;
      return {
        ...state,
        customStressTests: [
          ...state.customStressTests.slice(0, index),
          {
            ...state.customStressTests[index],
            needsSaving: false
          },
          ...state.customStressTests.slice(index + 1)
        ]
      }
    }
  }

  if (action.type === 'ADD_STRESS_TEST'){
    return {
      ...state,
      customStressTests:[
        { 
          ...action.test,
          permanent: false,
          needsSaving: true,
        },
        ...state.customStressTests,
      ]
    }
  }

  if (action.type === 'DELETE_STRESS_TEST'){
    if(action.id){
      return {
        ...state,
        customStressTests: action.pending
          ? state.customStressTests.map(o => o.id === action.id ? { ...o, pending: true } : o)
          : state.customStressTests.filter(o => o.id !== action.id)
      }
    } else if (action.index >= 0){
      return {
        ...state,
        customStressTests: [
          ...state.customStressTests.slice(0, action.index),
          ...state.customStressTests.slice(action.index + 1)
        ]
      }
    }
  }

  if (action.type === 'SET_STRESS_TEST_PROP'){
    return {
      ...state,
      customStressTests:[
        ...state.customStressTests.slice(0, state.selectedCustomStressTest),
        { 
          ...state.customStressTests[state.selectedCustomStressTest],
          needsSaving: true,
          [action.prop]: action.value,
        },
        ...state.customStressTests.slice(state.selectedCustomStressTest + 1)
      ]
    }
  }

  if(action.type === 'SET_STRESS_TEST_FACTORS'){
    return {
      ...state,
      customStressTests:[
        ...state.customStressTests.slice(0, state.selectedCustomStressTest),
        { 
          ...state.customStressTests[state.selectedCustomStressTest],
          needsSaving: true,
          factorShifts: {
            ...state.customStressTests[state.selectedCustomStressTest].factorShifts,
            ...action.factorShifts,
          },
        },
        ...state.customStressTests.slice(state.selectedCustomStressTest + 1)
      ]
    }
  }

  if (action.type === 'SET_STRESS_TEST_FACTOR'){
    return {
      ...state,
      customStressTests:[
        ...state.customStressTests.slice(0, state.selectedCustomStressTest),
        { 
          ...state.customStressTests[state.selectedCustomStressTest],
          needsSaving: true,
          factorShifts: {
            ...state.customStressTests[state.selectedCustomStressTest].factorShifts,
            [action.factor]: action.value
          },
        },
        ...state.customStressTests.slice(state.selectedCustomStressTest + 1)
      ]
    }
  }

  if (action.type === 'RESET_STRESS_TEST_FACTORS'){
    return {
      ...state,
      customStressTests:[
        ...state.customStressTests.slice(0, state.selectedCustomStressTest),
        { 
          ...state.customStressTests[state.selectedCustomStressTest],
          needsSaving: true,
          factorShifts: Object.keys(state.customStressTests[state.selectedCustomStressTest].factorShifts)
            .filter(k => k !== 'date')
            .reduce((t,v) => ({ ...t, [v]: 0 }), {})
        },
        ...state.customStressTests.slice(state.selectedCustomStressTest + 1)
      ]
    }
  }

  if (action.type === 'SELECT_CUSTOM_STRESS_TEST'){
    return {
      ...state,
      selectedCustomStressTest: action.index
    }
  }

  if (action.type === 'SET_CUSTOM_STRESS_TEST_MODE'){
    return {
      ...state,
      customStressTestIsBasic: action.basic
    }
  }

  if (action.type === 'SET_CUSTOM_STRESS_TEST_OPEN'){
    return {
      ...state,
      customStressTestIsOpen: action.open
    }
  }

  if (action.type === 'LOAD_SAVED_MONTE_CARLOS'){
    action.sims.forEach(e => {
      delete e._cls;
    })
    return {
      ...state,
      monteCarlos: [
        ...(action.sims.length 
          ? action.sims.map(t => ({ ...t, needsSaving: false }) )
          : []),
        ...state.monteCarlos.filter(t => t.id || t.permanent),
      ]
    }
  }

  if (action.type === 'SELECT_MONTE_CARLO'){
    return {
      ...state,
      selectedMonteCarlo: action.index
    }
  }

  if (action.type === 'SET_MONTE_CARLO_OPEN'){
    return {
      ...state,
      monteCarloIsOpen: action.open
    }
  }

  if (action.type === 'ADD_MONTE_CARLO'){
    return {
      ...state,
      monteCarlos: [
        { 
          ...action.sim,
          permanent: false,
          needsSaving: true,
        },
        ...state.monteCarlos,
      ]
    }
  }

  if (action.type === 'DELETE_MONTE_CARLO'){
    if(action.id){
      return {
        ...state,
        monteCarlos: action.pending
          ? state.monteCarlos.map(o => o.id === action.id ? { ...o, pending: true } : o)
          : state.monteCarlos.filter(o => o.id !== action.id)
      }
    } else if (action.index >= 0){
      return {
        ...state,
        monteCarlos: [
          ...state.monteCarlos.slice(0, action.index),
          ...state.monteCarlos.slice(action.index + 1)
        ]
      }
    }
  }

  if (action.type === 'SET_MONTE_CARLO_PROP'){
    return {
      ...state,
      monteCarlos:[
        ...state.monteCarlos.slice(0, state.selectedMonteCarlo),
        { 
          ...state.monteCarlos[state.selectedMonteCarlo],
          needsSaving: true,
          [action.prop]: action.value,
        },
        ...state.monteCarlos.slice(state.selectedMonteCarlo + 1)
      ]
    }
  }

  if (action.type === 'SET_MONTE_CARLO_SAVED'){
    if(action.saveAll){
      return {
        ...state,
        monteCarlos: [
          ...state.monteCarlos.filter(o => !o.permanent).map(d => ({ ...d, needsSaving: false })),
          ...state.monteCarlos.filter(o => o.permanent)
        ]
      }
    } else {
      let index = state.monteCarlos.map(d => d.id).indexOf(action.id) || state.selectedMonteCarlo;
      return {
        ...state,
        monteCarlos: [
          ...state.monteCarlos.slice(0, index),
          {
            ...state.monteCarlos[index],
            needsSaving: false
          },
          ...state.monteCarlos.slice(index + 1)
        ]
      }
    }
  }

  if (action.type === 'SET_MONTE_CARLO_FACTOR'){
    return {
      ...state,
      monteCarlos:[
        ...state.monteCarlos.slice(0, state.selectedMonteCarlo),
        { 
          ...state.monteCarlos[state.selectedMonteCarlo],
          needsSaving: true,
          [action.assumptions]: {
            ...state.monteCarlos[state.selectedMonteCarlo][action.assumptions],
            [action.factor]: action.value
          },
        },
        ...state.monteCarlos.slice(state.selectedMonteCarlo + 1)
      ]
    }
  }

  if (action.type === 'RESET_MONTE_CARLO_FACTORS'){
    return {
      ...state,
      monteCarlos:[
        ...state.monteCarlos.slice(0, state.selectedMonteCarlo),
        { 
          ...state.monteCarlos[state.selectedMonteCarlo],
          needsSaving: true,
          expectedVolatilityAssumptions: Object.keys(state.monteCarlos[state.selectedMonteCarlo].expectedVolatilityAssumptions)
            .filter(k => k !== 'date')
            .reduce((t,v) => ({ ...t, [v]: 0 }), {}),
          expectedReturnAssumptions: Object.keys(state.monteCarlos[state.selectedMonteCarlo].expectedReturnAssumptions)
            .filter(k => k !== 'date')
            .reduce((t,v) => ({ ...t, [v]: 0 }), {})
        },
        ...state.monteCarlos.slice(state.selectedMonteCarlo + 1)
      ]
    }
  }

  if (action.type === 'SET_DEFAULT_MONTE_CARLO_FACTORS'){
    const { expectedReturnAssumptions, expectedVolatilityAssumptions } = state.analysis[0].monteCarlos[0]
    return {
      ...state,
      monteCarlos:[
        ...state.monteCarlos.slice(0, state.selectedMonteCarlo),
        { 
          ...state.monteCarlos[state.selectedMonteCarlo],
          needsSaving: true,
          expectedReturnAssumptions,
          expectedVolatilityAssumptions,
        },
        ...state.monteCarlos.slice(state.selectedMonteCarlo + 1)
      ]
    }
  }

  if (action.type === 'SET_IMPORTANT_INFO_ACCEPTED'){
    return { ...state, importantInfoAccepted: true };
  }

  if (action.type === 'DPD_IS_OPEN'){
    return { ...state, dpdIsOpen: true };
  }

  return state;
};

export default (state, action) => {
  if (action.type === 'PRELOAD') {
    return action.state;
  }

  return {
    ...state,
    ...main(state, action),
    graphic: graphic(state.graphic, action),
  };
};



// WEBPACK FOOTER //
// ./src/reducer.js